import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircleIcon, XCircleIcon, XMarkIcon } from "@heroicons/react/24/solid";

export default function Notifications({ notifications, removeNotification }) {
  return (
    <div className="fixed top-4 w-full px-4 flex justify-center sm:justify-end z-[9999] pointer-events-none">
      {/* Pointer events disabled for wrapper */}
      <div className="flex flex-col space-y-2 max-w-sm w-full sm:w-auto">
        <AnimatePresence>
          {notifications.map((notif) => (
            <motion.div
              key={notif.id}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className={`bg-white shadow-lg rounded-lg p-4 flex items-start space-x-3 border ${notif.type === "success" ? "border-green-500" : "border-red-500"
                } relative z-[9999] pointer-events-auto`}
            // Pointer events enabled for notifications themselves
            >
              {notif.type === "success" ? (
                <CheckCircleIcon className="w-6 h-6 text-green-500" />
              ) : (
                <XCircleIcon className="w-6 h-6 text-red-500" />
              )}

              <div className="flex-1">
                <p className="font-semibold text-gray-800">{notif.title}</p>
                <p className="text-gray-600 text-sm">{notif.message}</p>
              </div>

              <button onClick={() => removeNotification(notif.id)}>
                <XMarkIcon className="w-5 h-5 text-gray-500 hover:text-gray-700" />
              </button>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
